import { render } from "./AddPartner.vue?vue&type=template&id=7ca5b15e&scoped=true"
import script from "./AddPartner.vue?vue&type=script&lang=js"
export * from "./AddPartner.vue?vue&type=script&lang=js"

import "./AddPartner.vue?vue&type=style&index=0&id=7ca5b15e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca5b15e"]])

export default __exports__